import { useState } from "react";
import { useDispatch } from "react-redux";
import Styles from "../editScreenStyles.module.css";
import useNoSpecialChars from "../../../../hooks/useNoSpecialChars";
import {
    alpahNumericRegex
} from "../../../../utilities/validationUtilities";

function PolicyNumberEdit({ policyNum, setPolicyNum, setIsVisible }) {
  const blankMessage = "- - -";
  const dispatch = useDispatch();
  const noSpecials = useNoSpecialChars();
  const [policy, setPolicy] = useState(policyNum);
  const [policyWarning, setPolicyWarning] = useState(false);

  const updateClicked = () => {
    dispatch(setPolicyNum(policy));
    setIsVisible(false);
  };

  const cancelClicked = () => {
    setPolicy(policyNum);
    setIsVisible(false);
  };

  // A policy number greater than 9 characters in length will cause the Mulesoft CNG to fail.
  const handlePolicyChange = (e) => {
    //if (e.target.value.length >= 9) {
    //  setPolicy(e.target.value.substring(0, 9));
    //  setPolicyWarning(true);
    //} else {
    //  setPolicyWarning(false);
    //  setPolicy(e.target.value);
      //}

      if (e.target.value) {
          if (!alpahNumericRegex.test(e.target.value)) {
              
          }
          else if (e.target.value.length > 7) {
              setPolicy(e.target.value.substring(0, 7));
          }

          else {

              dispatch(setPolicy(e.target.value));
          }

      }
      else { //allow empty
          (setPolicy(e.target.value));
      }
  };

  return (
    <div>
      <div className={Styles.title}>Policy Number</div>
      <div className={Styles.column}>
        <div className={Styles.row}>
          <label
            className={`${Styles.label} ${Styles.policyLabel}`}
            htmlFor="policy"
          >
            Policy Number:{" "}
          </label>
          <input
            id="policy"
            placeholder={blankMessage}
            value={policy}
            className={Styles.input}
            onChange={(e) => noSpecials(e) && handlePolicyChange(e)}
          />
        </div>
        {policyWarning && (
          <p className={Styles.policyLengthWarning}>
            {" "}
            *Policy number may not be more than 9 characters.
          </p>
        )}
        <div className={Styles.buttons}>
          <button
            type="button"
            className={Styles.button}
            onClick={cancelClicked}
          >
            Cancel
          </button>
          <button
            type="button"
            className={Styles.button}
            onClick={updateClicked}
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
}

export default PolicyNumberEdit;
